import { RequiredColorPalette } from '../types';

// TODO: zakazat onst palette = {} as PaletteOptions;
const palette: RequiredColorPalette = { primary: { main: '#15612c' } };

export default palette;
